import React from 'react';
import { withTranslation } from 'react-i18next';

import GuidedTour from 'components/common/GuidedTour/GuidedTour';
import './AssessmentGuidedTour.scss';

export const SHOW_ASSESSMENT_GUIDED_TOUR_KEY = '3pp_show_assessment_guided_tour';

export const AssessmentGuidedTour = props => {
  const { t, setTriggerGuidedTour, isMobile } = props;
  const steps = [];

  isMobile &&
    steps.push(
      {
        target: '.guided-tour-hamburger-menu',
        title: t('guidedTour.assessment.hamburgerMenu.title'),
        content: t('guidedTour.assessment.hamburgerMenu.content'),
        placement: 'top',
        styles: {
          spotlight: {
            borderRadius: '30%'
          }
        },
        disableBeacon: true
      },
      {
        target: '.guided-tour-mobile-menu',
        title: t('guidedTour.assessment.mobileMenu.title'),
        content: t('guidedTour.assessment.mobileMenu.content'),
        placement: 'left',
        styles: {
          spotlight: {
            borderRadius: '0 0 0 80%'
          }
        },
        disableBeacon: true // trigger tour manually via useEffect
      },
      {
        target: '.guided-tour-mobile-submit-assessment',
        title: t('guidedTour.assessment.submitAssessment.title'),
        content: t('guidedTour.assessment.submitAssessment.content'),
        placement: 'top',
        styles: {
          spotlight: {
            borderRadius: '90% 90% 0 0 '
          }
        }
      }
    );

  !isMobile &&
    steps.push(
      {
        target: '.guided-tour-hamburger-menu',
        title: t('guidedTour.assessment.hamburgerMenu.title'),
        content: t('guidedTour.assessment.hamburgerMenu.content'),
        placement: 'top',
        styles: {
          spotlight: {
            borderRadius: '30%'
          }
        },
        disableBeacon: true
      },
      {
        target: '.guided-tour-category-list',
        title: t('guidedTour.assessment.categoryList.title'),
        content: t('guidedTour.assessment.categoryList.content'),
        offset: -80,
        placement: 'right',
        floaterProps: {
          disableFlip: true,
          styles: {
            floater: {
              marginTop: -30
            },
            arrow: {
              margin: 50
            }
          }
        },
        styles: {
          spotlight: {
            borderRadius: '0 0 70% 0'
          }
        },
        disableBeacon: true // trigger tour manually via useEffect
      },
      {
        target: '.guided-tour-right-panel',
        title: t('guidedTour.assessment.rightPanel.title'),
        content: t('guidedTour.assessment.rightPanel.content'),
        placement: 'left',
        styles: {
          spotlight: {
            borderRadius: '70%'
          }
        }
      },
      {
        target: '.guided-tour-submit-assessment',
        title: t('guidedTour.assessment.submitAssessment.title'),
        content: t('guidedTour.assessment.submitAssessment.content'),
        placement: 'top-end',
        offset: -40,
        floaterProps: {
          disableFlip: true,
          styles: {
            floater: {
              marginRight: 120
            }
          }
        },
        styles: {
          spotlight: {
            borderRadius: '80%'
          }
        }
      }
    );
  const onTourComplete = isDone => {
    if (isDone) {
      localStorage.setItem(SHOW_ASSESSMENT_GUIDED_TOUR_KEY, false);
      setTriggerGuidedTour();
    }
  };

  return (
    <GuidedTour
      onTourComplete={onTourComplete}
      steps={steps}
      locale={{
        next: t('guidedTour.continue'),
        back: t('guidedTour.back'),
        last: t('guidedTour.last'),
        skip: t('guidedTour.skip'),
        close: t('guidedTour.close')
      }}
    />
  );
};

export default withTranslation()(AssessmentGuidedTour);
